import { createContext, useContext, useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router";

const CODDataContext = createContext();

export const CODDataProvider = ({ children }) => {
  const location = useLocation();
  const [newData, setNewData] = useState([]);
  const [safData, setSafData] = useState([]);
  const [soData, setSoData] = useState([]);
  const [soDataScribe, setSoDataScribe] = useState([]);
  const [isWaiting, setIsWaiting] = useState(false);
  const [isSafWaiting, setIsSafWaiting] = useState(false);
  const [isSoNotComplete, setIsSoNotComplete] = useState(false);
  const [talkData, setTalkData] = useState([]);
  const [isTalkWaiting, setisTalkWaiting] = useState(false);

  const [alertData, setAlertData] = useState([]);
  const [isAlertWaiting, setisAlertWaiting] = useState(false);

  const [alertAgentData, setAlertAgentData] = useState([]);
  const [isAlertAgentWaiting, setIsAlertAgentWaiting] = useState(false);

  const [nurseCODData, setNurseCODData] = useState([]);
  const [isNurseCODWaiting, setIsNurseCODWaiting] = useState(false);

  useEffect(() => {
    const waiting = newData.some(
      (item) =>
        item.requestStatus === "REQUESTED" ||
        item.requestStatus === "BACK_TO_QUEUE"
    );
   
    setIsWaiting(waiting);
  }, [newData]);

  useEffect(() => {
    const waiting = talkData.some((item) => item.requestStatus === "REQUESTED");

    
    setisTalkWaiting(waiting);
  }, [talkData]);

  useEffect(() => {
    const waiting = alertData.some(
      (item) => item.requestStatus === "REQUESTED"
    );
     
    setisAlertWaiting(waiting);
  }, [alertData]);

  useEffect(() => {
    const waiting = alertAgentData.some(
      (item) =>
        item?.alertType === "COD_CONSULTATION" &&
        item.requestStatus === "REQUESTED"
    );
     
    setIsAlertAgentWaiting(waiting);
  }, [alertAgentData]);

  useEffect(() => {
    const waiting = nurseCODData.some(
      (item) => item.requestStatus === "REQUESTED"
    );

   
    setIsNurseCODWaiting(waiting);
  }, [nurseCODData]);

  useEffect(() => {
    const safWaiting = safData.some(
      (item) =>
        item.requestStatus === "REQUESTED" ||
        (item.requestStatus === "RESUBMITTED" &&
          item?.servicedByProviderId === localStorage.getItem("providerId"))
    );
    
    setIsSafWaiting(safWaiting);
  }, [safData]);

  useEffect(() => {
    const soNotComplete = soData.some(
      (item) => item.requestStatus !== "COMPLETED"
    );

    setIsSoNotComplete(soNotComplete);
  }, [soData]);


  useEffect(() => {
    // const soNotCompleteScribe = soDataScribe.some(
    //   (item) => item.requestStatus !== "TRANSCRIBED"
    // );

   //   console.log("waitingwaiting18",soNotCompleteScribe);
   // setIsSoNotComplete(soNotComplete);
  }, [soDataScribe]);

  const isAlertActive = useMemo(() => {
    return (
      (isWaiting || isSafWaiting || isSoNotComplete) &&
      !location.pathname.includes("/consultations") &&
      !location.pathname.includes("/consultation")
    );
  }, [isWaiting, location.pathname, isSafWaiting, isSoNotComplete]);

  useEffect(() => {
    document.title = isAlertActive
      ? "\u26A0 Alert | Merago - Provider Portal"
      : "Merago - Provider Portal";
  }, [isAlertActive]);

  return (
    <CODDataContext.Provider
      value={{
        newData,
        setNewData,
        isWaiting,
        setSafData,
        safData,
        setSoData,
        soData,
        setSoDataScribe,
        soDataScribe,
        isSafWaiting,
        isSoNotComplete,
        setTalkData,
        setAlertData,
        talkData,
        isTalkWaiting,
        alertData,
        isAlertWaiting,
        setAlertAgentData,
        isAlertAgentWaiting,
        alertAgentData,
        nurseCODData,
        setNurseCODData,
        isNurseCODWaiting,
      }}
    >
      {children}
    </CODDataContext.Provider>
  );
};

export const useCODData = () => {
  return useContext(CODDataContext);
};
